import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { debounce } from 'lodash';

import Sidebar from '../Sidebar';
import Main from '../Main';
import BarLoader from '../common/loaders/BarLoader';
import { logoutUser } from '../../store/auth/actions';
import { fetchData } from '../../store/data/actions';
import { setView } from '../../store/files/actions';
import { closeDropdowns } from '../../store/actions';
import { getIsValidatingUser } from '../../store/auth/reducer';
import * as files from '../../store/files/reducer';
import './dashboard.css';

class Dashboard extends Component {
	
	componentDidMount() {
		this.props.fetchData();
		window.addEventListener('resize', this.handleResize);
		this.handleResize();
	}

	handleResize = debounce(() => {
		if (window.innerWidth < 992) { 
			this.props.setView("grid");
		}
	}, 100)

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}
	
	
	render() {
		const { 
			logoutUser,
			isFetching,
			isValidatingUser,
			closeDropdowns
		} = this.props;

		if (isFetching || isValidatingUser) {
			return <BarLoader title="Loading" />
		}

		return (
			<div className="dashboard">
				<aside className="dashboard__aside">
					<Sidebar onLogoutClick={logoutUser} onNavClick={closeDropdowns} />
				</aside>
				<main className="dashboard__main">
					<Main />
				</main>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		isFetching: files.getIsFetching(state.files),
		isValidatingUser: getIsValidatingUser(state.auth),
	}
}

export default withRouter(connect(mapStateToProps, { 
	logoutUser, 
	fetchData, 
	setView,
	closeDropdowns,
})(Dashboard));


// WEBPACK FOOTER //
// ./src/components/Dashboard/index.js